import React from "react";
import "../css/sectiontitle.css";

const SectionTitle = ({ title_text, id }) => {
    return (
        <div id={id} className="section-title-container">
            <h1>{title_text}</h1>
        </div>
    );
};

export default SectionTitle;
